{
  "version": 1,
  "asset_id": "8acc2338-8347-4eb5-b8be-63cbaa8441e7",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/8acc2338-8347-4eb5-b8be-63cbaa8441e7/sleeve-excess-weight-loss-percentage-graph-720.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/8acc2338-8347-4eb5-b8be-63cbaa8441e7/sleeve-excess-weight-loss-percentage-graph-720.png",
  "original_filename": "sleeve-excess-weight-loss-percentage-graph-720.png",
  "size": 69220,
  "content_type": "image/png",
  "created_at": "2026-09-29T01:09:27Z"
}
